export function propertyActionAllowed(property, module, action, fallback = false) {
  if (!property?._collaborationPermissions && !property?.collaborationPermissions) return fallback;
  const permissions = property._collaborationPermissions || property.collaborationPermissions;
  return (permissions[module] || []).includes(action);
}
export function attachCollaborationPermissions(property, invitations, userId) {
  if (property._accessRole === 'owner') return property;
  const grants = (invitations || []).filter(i => i.status === 'accepted' && i.user_id === userId
    && i.property_ids?.map(String).includes(String(property.id)));
  if (!grants.length) return property;
  const permissions = {};
  grants.forEach(grant => Object.entries(grant.access_active === false ? {} : (grant.effective_permissions || grant.permissions || {})).forEach(([module, actions]) => {
    permissions[module] = [...new Set([...(permissions[module] || []), ...actions])];
  }));
  return { ...property, _collaborationPermissions: permissions, _collaborationRoles: grants.map(i => i.role), _collaborationInviteIds: grants.map(i => i.id) };
}

export function propertiesForModule(properties, module) {
  if (!module) return properties;
  return properties.filter(property => propertyActionAllowed(property, module, 'view', true)
    || (module === 'caderno' && propertyActionAllowed(property, module, 'execute')));
}
